export const ENROLLING = 'Enrolling';
export const CANCELED = 'Canceled';
export const CLOSED = 'Closed';
export const STARTUP = 'Startup';
export const TREATMENT = 'Treatment';
